import React from 'react';

import { Stack, Typography } from '@gogame/components';
import { ScreenLink, useScreenState } from '@gogame/screens';

import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/view-constants';
import {
  CONCEPT_FAMILY_ID,
  TAB_CONCEPTS,
} from 'scenes/Gallery/GalleryPage/constants';
import { conceptFamilyPreviewLink } from 'scenes/Gallery/GalleryPage/navigation';

const DetailsColumn = ({ row }) => {
  const screenState = useScreenState();
  const {
    [CONCEPT.ID]: id,
    [CONCEPT.NAME]: name,
    [CONCEPT.APPLICATIONS]: applications,
    [CONCEPT.DESCRIPTION]: description,
  } = row;

  const applicationsList = applications?.join(', ');

  return (
    <Stack spacing={0.5} zeroMinWidth={true}>
      <Typography variant={'body2'} noWrap={true}>
        <ScreenLink
          data-cy={'Concept Family Page'}
          link={conceptFamilyPreviewLink.child(TAB_CONCEPTS)}
          pathParams={{
            [CONCEPT_FAMILY_ID]: id,
          }}
          searchParams={{
            filters: screenState.filters,
          }}
          underline={'always'}
        >
          {name}
        </ScreenLink>
      </Typography>

      <Typography variant={'caption'} noWrap={true}>
        {applicationsList}
      </Typography>

      <Typography variant={'caption'} noWrap={true}>
        {description}
      </Typography>
    </Stack>
  );
};

export default DetailsColumn;
